import {AccountBean} from 'common/api/api'
import {FC} from 'react'
import {DictionarySelector, DictionarySelectorProps, enumToLabelValue} from './DictionarySelector'
import RoleEnum = AccountBean.RoleEnum

export interface RoleSelectorProps extends DictionarySelectorProps {
  allowSuperAdmin?: boolean
}

export const RoleSelector: FC<RoleSelectorProps> = ({allowSuperAdmin, ...restProps}) => {
  const cacheKey = allowSuperAdmin ? 'role_with_superadmin' : 'role_without_superadmin'

  const loader = () =>
    enumToLabelValue(RoleEnum).then(options =>
      allowSuperAdmin
        ? options.filter(option => option.id !== String(RoleEnum.Publisher))
        : options.filter(option => option.id !== String(RoleEnum.Publisher) && option.id !== String(RoleEnum.SuperAdmin))
    )

  return (
    <DictionarySelector
      {...restProps}
      cacheKey={cacheKey}
      loader={loader}
    />
  )
}
